import PageHeader from "@/components/layout/PageHeader";
import ContactMap from "@/components/home/ContactMap";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <>
      <PageHeader
        eyebrow="Contact"
        title="Talk to us — we're happy to help."
        subtitle="Call, WhatsApp or write to us. We usually respond within a few working hours."
      />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
          <div className="lg:col-span-2">
            <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-2xl p-6">
              <h3 className="font-display text-xl font-bold">Prefer to visit?</h3>
              <p className="mt-2 text-[#6B7280]">Head over to our counter next to the Bally Toll Plaza. See the map below for directions.</p>
            </div>
          </div>
        </div>
      </section>
      <ContactMap />
    </>
  );
}
